import { defineMessages } from "react-intl";

export const FbaV3ProductErrorLabels = defineMessages({
  skuQuantityExceeded: {
    id: "fbaV3.productError.skuQuantityExceeded",
    defaultMessage: "The number of units of an SKU cannot exceed {maxUnitsOfSku} in an FBA inbound plan.",
  },
});
